import React from 'react';
import Logo from 'images/adpkd-registry-logo.svg';
import { isMobile } from 'utils/isMobile';
import { DesktopHeaderWrapper, MobileHeaderWrapper } from './styles';

const PKDHeader = () => {
  if (!isMobile()) {
    return (
      <DesktopHeaderWrapper
        data-testid='DesktopHeaderWrapper'>
        <img
          alt='pkd-logo' src={Logo} height='100%' data-testid='PKDHeader'
        />
      </DesktopHeaderWrapper>
    );
  }
  return (
    <MobileHeaderWrapper
      data-testid='MobileHeaderWrapper'>
      <img
        alt='pkd-logo' src={Logo} height='100%' data-testid='PKDHeader'
      />
    </MobileHeaderWrapper>
  );
};

export default PKDHeader;
